import { usePrenuvoStore } from '@/stores/usePrenuvoStore';
import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

export const useGlobalLoading = (condition: boolean, priority = false) => {
  const { setInitialLoading, loadingState, loadingPriority } = usePrenuvoStore(
    useShallow((state) => ({
      setInitialLoading: state.ui.methods.setInitialLoading,
      loadingState: state.ui.loading.state,
      loadingPriority: state.ui.loading.priority,
    })),
  );

  useEffect(() => {
    if (priority) {
      setInitialLoading(condition, priority);
      return;
    }
    
    const isLowerPriorityLoading = loadingState && !loadingPriority;

    if (!loadingState || isLowerPriorityLoading) setInitialLoading(condition, priority);
  }, [condition, priority]);
};
